<template>
	<b-modal v-model="isOpen" title="Ordem de Serviço" size="xl" scrollable centered hide-footer>
		<template v-if="file && serviceOrder">

			<b-button class="print-button" @click="print">Imprimir</b-button>

			<div id="service-order-view">

				<header>
					<div class="left">
						<h5><b>Ordem de Serviço {{ serviceOrder.fileNumber }}</b></h5>
						<b>Guia Principal da OS: {{ serviceOrder.mainGuide && serviceOrder.mainGuide.name }}</b>
					</div>
					<span class="right" v-if="file.company && file.company.logoPath">
						<img :src="file.company.logoPath" :alt="file.company.name" />
					</span>
				</header>

				<br><br>

				<section class="info">
					<div class="item">
						<b>Pax</b> <br>
						<span>{{ file.pax }}</span>
					</div>
					<div class="item">
						<b>Nº Pax</b> <br>
						<span>{{ file.paxQty }}</span>
					</div>

					<div class="item">
						<b>File</b> <br>
						<span>{{ file.fileNumber }}</span>
					</div>

					<div v-if="file.client" class="item">
						<b>Cliente</b> <br>
						<span>{{ file.client.name }}</span>
					</div>

					<div v-if="file.country" class="item">
						<b>País</b> <br>
						<span>{{ file.country.name }}</span>
					</div>

					<div v-if="file.language" class="item">
						<b>Idioma</b> <br>
						<span>{{ file.language.name }}</span>
					</div>

					<div v-if="file.operator" class="item">
						<b>Operador</b> <br>
						<span>{{ file.operator.name }}</span>
					</div>
				</section>

				<template v-if="file.company">
					<hr>
					<section class="company">
						Faturar a: {{ file.company.name }} - Cnpj: {{ file.company.cnpj }}
					</section>
				</template>

				<hr>

				<b>Serviços do File</b>
				<br><br>

				<section class="bookings">
					<div class="header">
						<b class="hdate">Data</b>
						<b class="hservice">Serviço</b>
						<b class="hpickup">Pick up</b>
						<b class="hduration">Duração</b>
						<b class="hesp">ESP</b>
						<b class="hguide">Guia</b>
					</div>

					<div v-for="booking in filteredBookings" :key="booking.id" class="booking">
						<span class="date">{{ booking.booking.date }}</span>
						<span class="service">{{ booking.booking.service && booking.booking.productName}}</span>
						<span class="pickup">{{ booking.pickup }}</span>
						<span class="duration">{{ booking.duration }}</span>
						<span class="esp">{{ booking.booking.allocationType }}</span>
						<span class="guide">{{ booking.guide && booking.guide.name }}</span>

						<span class="pre-descriptive">-</span>
						<span class="descriptive">{{booking.showServiceDescription ? booking.booking.description : ''}}</span>

						<span class="bookingNumber">{{ booking.booking.bookingNumber }}</span>
						<span class="pax">
							<span v-if="file.pax">Pax: {{ file.pax }}</span>
							<span v-if="booking.booking.paxQty">Nº Pax: {{ booking.booking.paxQty }}</span>
							<span v-if="booking.booking.flightTimeInformation">Hora: {{ booking.booking.flightTimeInformation }}</span>
							<span v-if="booking.booking.flightNumberInformation">VOO:
								{{ booking.booking.flightNumberInformation }}</span>
							<span v-if="booking.booking.flightOriginInformation">ORIG.:
								{{ booking.booking.flightOriginInformation }}</span>
							<span v-if="booking.booking.flightDestinationInformation">DEST.:
								{{ booking.booking.flightDestinationInformation }}</span>
								<span v-if="booking.booking.guests && booking.booking.guests.length" class="pax-names">
								{{ formatGuests(booking.booking.guests) }}
							</span>
						</span>

						<span class="empty">-</span>
						<span class="providers">
							<div v-if="serviceOrder.hotel">Hotel: {{ serviceOrder.hotel.name }}</div>
							<div v-if="booking.providerLabel">
								Fornecedor: {{booking.providerLabel}}
							</div>
							<div>
								Local pick-up: {{ booking.pickupPlace || serviceOrder.principalPoint }} - Local drop-off:
								{{ booking.dropoffPlace
		|| serviceOrder.principalPoint }}
							</div>
						</span>
					</div>
				</section>

				<br><br>

				<section class="os-obs">
					<b>Observação do Operador</b>
					<br><br>
					<p class="obs-text">{{ serviceOrder.operatorObs }}</p>
				</section>

				<hr>

				<section class="guide-obs">
					<b>Observação do Handling</b>
					<br><br>
					<p class="obs-text">{{ serviceOrder.handlingObs }}</p>
				</section>

				<hr>

				<section class="client-to-guide-obs">
					<b>Observação do Cliente</b>
					<br><br>
					<p class="obs-text">{{ serviceOrder.clientToGuideObs }}</p>
				</section>

				<hr>

				<p>
					É obrigação do guia: <br>
					*** Dress Code: lembramos que o uso da camisa entregue pelo Handling é obrigatório. <br>
					*** Entrar em contato com o telefone do PLANTÃO caso ocorra um problema, queira fazer um comentário, pedido de alteração, mudança de voo ou qualquer outra dúvida. <br>
					*** Ligar para recepção do hotel para ter certeza que a reserva está ok. <br>
					*** Verificar o voo, para ter certeza que o mesmo não está atrasado, adiantado ou cancelado! <br>
					*** Check in no aeroporto - o guia precisa fazer o check in com o pax e caso tenha alguma mudança no voo, a Blumar precisa ser avisada imediatamente! <br>
				</p>

			</div>

			<div id="service-order-view-mobile">
				<b-card no-body>
					<span class="right" v-if="file.company && file.company.logoPath">
						<img :src="file.company.logoPath" :alt="file.company.name" />
					</span>
					<b-tabs card justified>
						<b-tab title="Geral">
							<header>
								<div class="left">
									<h5><b>Ordem de Serviço {{ serviceOrder.fileNumber }}</b></h5>
									<b>Guia Principal da OS: {{ serviceOrder.mainGuide && serviceOrder.mainGuide.name }}</b>
								</div>
							</header>
							<section>
								<div>
									<span><b>Pax:</b> {{ file.pax }}</span> <br />
									<span><b>Nº Pax:</b> {{ file.paxQty }}</span> <br />
									<span><b>File:</b> {{ file.fileNumber }}</span> <br />
									<span><b>Cliente:</b> {{ file.client.name }}</span> <br />
									<span><b>País:</b> {{ file.country.name }}</span> <br />
									<span><b>Idioma:</b> {{ file.language.name }}</span> <br />
									<span><b>Operador:</b> {{ file.operator.name }}</span> <br />
									<hr />
									<section class="company">
										<b>Faturar a:</b> {{ file.company.name }} <b>- Cnpj:</b> {{ file.company.cnpj }}
									</section>
									<hr />
									<p><b>É obrigação do guia:</b><br>
										<ul>
											<li>Dress Code: lembramos que o uso da camisa entregue pelo Handling é obrigatório.</li>
											<li>Entrar em contato com o telefone do PLANTÃO caso ocorra um problema, queira fazer um comentário, pedido de alteração, mudança de voo ou qualquer outra dúvida.</li>
											<li>Ligar para recepção do hotel para ter certeza que a reserva está ok.</li>
											<li>Verificar o voo, para ter certeza que o mesmo não está atrasado, adiantado ou cancelado!</li>
											<li>Check in no aeroporto - o guia precisa fazer o check in com o pax e caso tenha alguma mudança no voo, a Blumar precisa ser avisada imediatamente!</li>
										</ul>
									</p>
								</div>
							</section>
						</b-tab>
						<b-tab title="Serviços">
							<div v-for="booking, i in filteredBookings" :key="i">
								<h5><b>{{ booking.booking.bookingNumber }} - {{ booking.booking.date }}</b></h5><br />
								<span><b>Serviço:</b> {{ booking.booking.service && booking.booking.productName }}</span> <br />
								<span><b>Pick up:</b> {{ booking.pickup }}</span> <br />
								<span><b>Duração:</b> {{ booking.duration }}</span> <br />
								<span><b>ESP:</b> {{ booking.booking.allocationType }}</span> <br />
								<span><b>Guia:</b> {{ booking.guide && booking.guide.name }}</span> <br />
								<br />
								<span><b>Nº Pax:</b> {{ booking.booking.paxQty }}</span> <br />
								<span><b>Hora:</b> {{ booking.booking.flightTimeInformation }}</span> <br />
								<span><b>Voo:</b> {{ booking.booking.flightNumberInformation }}</span> <br />
								<span><b>ORIG.:</b> {{ booking.booking.flightOriginInformation }}</span> <br />
								<span><b>DEST.:</b> {{ booking.booking.flightDestinationInformation }}</span> <br />
								<br />
								<span v-if="serviceOrder.hotel"><b>Hotel:</b> {{ serviceOrder.hotel.name }}</span> <br/>
								<span><b>Fornecedor:</b> {{ providerLabel(booking) }}</span> <br/>
								<span><b>Local pick-up:</b> {{ booking.pickupPlace || serviceOrder.principalPoint }}</span> <br/>
								<span><b>Local drop-off:</b> {{ booking.dropoffPlace || serviceOrder.principalPoint }}</span> <br/>
								<br />
								<hr v-if="i < filteredBookings.length - 1">
							</div>
						</b-tab>
						<b-tab title="Observação">
							<section class="os-obs">
								<b>Observação do Operador:</b><br/>
								<p class="obs-text">{{ serviceOrder.operatorObs }}</p>
							</section>
							<hr/>
							<section class="guide-obs">
								<b>Observação do Handling</b>
								<br><br>
								<p class="obs-text">{{ serviceOrder.handlingObs }}</p>
							</section>
							<hr/>
							<section class="client-to-guide-obs">
								<b>Observação do Cliente</b>
								<br><br>
								<p class="obs-text">{{ serviceOrder.clientToGuideObs }}</p>
							</section>
						</b-tab>
					</b-tabs>
				</b-card>
			</div>
		</template>
	</b-modal>
</template>

<script>
import { ReservationStatus } from '../../enums/ReservationStatus';

let EServiceType = {
	HOTEL: { id: 1, name: "Hotel" },
	TOUR: { id: 2, name: "Tour" },
	TRANSFER: { id: 3, name: "Transfer" },
	GUIDE: { id: 4, name: "Guia" },
	MEAL: { id: 5, name: "Alimentacao" },
	TICKET: { id: 6, name: "Ticket" },
	EXTRA: { id: 7, name: "Extra" },
	TRANSPORTATION: { id: 8, name: "Transporte" },
};

export default {
	computed: {
		filteredBookings() {
			if(!this.serviceOrder || !this.serviceOrder.bookings) return [];
			return this.serviceOrder.bookings
				.filter(booking => booking.booking.status.id === ReservationStatus.KK.id)
				.map(booking => Object.assign({}, booking, { providerLabel: this.providerLabel(booking) }));
		}
	},
	data() {
		return {
			isOpen: false,
			file: undefined,
			serviceOrder: undefined,
		};
	},
	methods: {
		open(file, serviceOrder) {
			this.isOpen = true;
			this.file = file;
			this.serviceOrder = serviceOrder;
		},
		print() {
			this.$htmlToPaper('service-order-view');
		},
		providerLabel(booking) {
			let findType = (type) => {
				if(booking.items.find(item => item.service.serviceType.id === type.id))
					return type;
			};

			let mainType = findType(EServiceType.TRANSPORTATION)
				|| findType(EServiceType.TRANSFER)
				|| findType(EServiceType.TOUR);
			if(mainType) {
				let items = booking.items.filter(item => item.service.serviceType.id === mainType.id);
				return items.map(i => `${i.provider.name || ''} - ${i.provider.phone || ''}`).join(` / `);
			}
			return null;
		},
		formatGuests(guests) {
    	return guests.map(g => g.name).join(' / ');
  	}
	}
}
</script>

<style src="../../../static/css/service-order-view.css" scoped></style>



// WEBPACK FOOTER //
// src/components/os/ServiceOrderView.vue